export const ROUND_SELECT = 'ROUND_SELECT';
export const SET_AUTO_SWITCH = 'SET_AUTO_SWITCH';

export const roundSelect = (round, categories) => ({
  type: ROUND_SELECT,
  payload: { round, categories },
});

export const setAutoSwitch = (value) => ({
  type: SET_AUTO_SWITCH,
  payload: { autoSwitch: value },
});
